import React, { Component } from 'react';
import { Container } from 'flux/utils';
import { dispatch } from '../../dispatcher/Dispatcher';

import { getItem as getLang } from '../../common/lang';

import Header from '../../components/Header/Header.jsx';
import PullLoader from '../../components/PullLoader/PullLoader.jsx';
import RecordList from '../../components/RecordList/RecordList.jsx';
import FormControl from '../../components/FormControl/FormControl.jsx';
import TextInput from '../../components/TextInput/TextInput.jsx';
import Button from '../../components/Button/Button.jsx';
import Form from '../../components/Form/Form.jsx';
import Loader from '../../components/Loader/Loader.jsx';
import PageOpener from '../../components/PageOpener/PageOpener.jsx';

import RepairClockInStore from '../../stores/RepairClockInStore';
import RepairClockInDataUtils from '../../data-utils/RepairClockInDataUtils';


class RepairClockInMgrHistory extends Component {

	static getStores() {
		return [RepairClockInStore];
	}

	static calculateState() {
		return RepairClockInStore.getState();
	}

	constructor(props) {
		super(props);

	}

    render(){
		const{
			submitting = false,
			selectTable,
			empRciList = [{
				id: 1,
				essCode: '9527',
				startTime: '2017/16/15 09:00',
				endTime: '2017/16/15 18:00',
				content: '打卡机坏了',
				status: 'approved'
			},
			{
				id: 2,
				essCode: '9527',
				startTime: '2017/16/15 09:00',
				endTime: '2017/16/15 18:00',
				content: '忘记了',
				status: 'pending'
			},
			{
				id: 3,
				essCode: '9527',
				startTime: '2017/16/15 09:00',
				endTime: '2017/16/15 18:00',
				content: '停电了',
				status: 'pending'
			},
			{
				id: 4,
				essCode: '9527',
				startTime: '2017/16/15 09:00',
				endTime: '2017/16/15 18:00',
				content: '系统出错了',
				status: 'approved'
			},
			{
				id: 5,
				essCode: '9527',
				startTime: '2017-16-15 09:00',
				endTime: '2017-16-15 18:00',
				content: '打卡机坏了',
				status: 'approved'
			},
			{
			id: 6,
			essCode: '9527',
			startTime: '2017/16/15 09:00',
			endTime: '2017/16/15 18:00',
			content: '打卡机坏了',
			status: 'approved'
		}],
			status = 'loading'
		} = this.state;
        return (
            <div>
                <Header
					back
					title={'审批历史'}
				/>
				<ul className={'record-list' + (selectTable ? ' record-list-selectable' : '')}>
					{
					empRciList.map((record, index) => {
						return (
						<li>
							<a className='record-item' href={`#/my-rci/record/1`}>
								<span className='record-item-name'>{record.empName} - {record.app_001_c001v}</span>
								<span className='record-item-time'>{record.startTime} - {record.endTime}</span>
								<span className={'record-item-status record-item-status-' + record.status}>{record.status}</span>
							</a>
						</li>
						);
					})}
				</ul>
				<Button icon='plus' action onClick={::this.openApply} />

				<PageOpener ref='apply'>
					<Loader status={'loaded'}>
						<div className='login-forgot-page'>
								<FormControl label={'理由'} tips={getLang('REQUIRED')}>
									<TextInput ref='tbReason' id='tbReason' name='tbReason'
											type='text' required />
								</FormControl>
								<FormControl label={'开始时间'} tips={getLang('REQUIRED')}>
									<TextInput ref='tbStartTime' id='tbStartTime' name='tbStartTime'
											type='datetime' required />
								</FormControl>
								<FormControl label={'结束时间'} tips={getLang('REQUIRED')}>
									<TextInput ref='tbEndTime' id='tbEndTime' name='tbEndTime'
											type='datetime' required />
								</FormControl>
						</div>
						<div className="row">
							<div className="col-1-2">
								<Button type='button'
												disabled={submitting}
												text={getLang('SAVE')}/>
							</div>
							<div className="col-1-2">
								<Button type='button'
												disabled={submitting}
												text={getLang('SUBMIT')}/>
							</div>
						</div>
					</Loader>
				</PageOpener>
            </div>
        );
    }

	openApply(e){
		this.refs.apply.open(e);
	}

}

export default Container.create(RepairClockInMgrHistory);



// WEBPACK FOOTER //
// ./src/containers/RepairClockIn/RepairClockInMgrHistoryContainer.js